interface BlockSettingTrailingButtonProps {
  text: string;
  onClick: () => void;
}

const BlockSettingTrailingButton: React.FC<BlockSettingTrailingButtonProps> = ({ text, onClick }) => {
  return (
    <button className="flex h-[38px] w-[72px] items-center justify-center self-start rounded-md border-0 bg-btn-bg-normal p-[var(--spacing-xs)]">
      <span onClick={onClick} className="typography-headline-md text-btn-txt-normal">
        {text}
      </span>
    </button>
  );
};

export default BlockSettingTrailingButton;
